import { ChangeBranchActions } from "@DSG/Store/Pages/Header/ChangeBranch/ChangeBranchReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

export interface ChangeBranchParameter {
    changeBranch: boolean;
}
type HandlerType = Handler<ChangeBranchParameter, DispatchProp<ChangeBranchActions>>;
export const ResetBranchPopup: HandlerType = props => {
    props.dispatch({
        type: "ChangeBranch/Popup/Reset",
    });
};
export const OpenChangeBranchPopup: HandlerType = props => {
    props.dispatch({
        type: "ChangeBranch/Popup/Flag",
        changeBranch: props.parameter.changeBranch,
    });
};

export const chain = [ResetBranchPopup, OpenChangeBranchPopup];

const changeBranchPopup = createHandlerChainRunner(chain, "ChangeBranchPopup");
export default changeBranchPopup;
